import { useClickOutside } from 'stimulus-use';
import ApplicationController from './application_controller';

// Connects to data-controller="hamburger-menu"
export default class extends ApplicationController {
  static targets = ['btn', 'drawer'];

  connect() {
    super.connect();
    useClickOutside(this);
    this.#animationReady();
  }

  clickOutside() {
    this.hide();
  }

  toggle() {
    this.btnTarget.classList.toggle('is-active');
    this.drawerTarget.classList.toggle('is-active');
  }

  hide() {
    this.btnTarget.classList.remove('is-active');
    this.drawerTarget.classList.remove('is-active');
  }

  #animationReady() {
    this.btnTarget.classList.remove('no-transition');
    this.drawerTarget.classList.remove('no-transition');
  }
}
